import cognito from "./cognito";

const aws = {
    cognito
};

export default aws;